export default __webpack_public_path__ + "static/create-service-gateway-0d75d662fb4d1fc306ca70baa96fab0b.jpg";